module.exports = __webpack_public_path__ + "static/img/frontlogo.9007e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/frontlogo.png
// module id = yo+b
// module chunks = 51